import { CustomMarkerBuilderI } from 'src/app/interfaces/map.interface';
import { CustomMarker, Icon, Size } from 'src/app/models/custom-marker.model';
import MapSettings from '../../map.settings';

export interface CustomMarkerBuilder {
  getIconUrl?(): string;
}

export abstract class CustomMarkerBuilder implements CustomMarkerBuilderI {
  protected marker: CustomMarker;

  public constructor(kind: string) {
    this.resetMarker(kind);
  }

  public setMarkerId(data: object): void {
    this.marker.id = this.getMarkerId(data);
  }

  public setCoords(latitude: number, longitude: number): void {
    this.marker.latitude = latitude;
    this.marker.longitude = longitude;
  }

  public setIcon(itemsCount: number): void {
    this.marker.icon = this.formIcon(this.configureScaledSize(itemsCount));
  }

  public buildMarker(): CustomMarker {
    const customMarker: CustomMarker = this.marker;
    this.resetMarker(this.marker.kind);

    return customMarker;
  }

  public resetMarker(kind: string): void {
    this.marker = new CustomMarker(kind);
  }

  protected abstract getMarkerId(data: object): string;

  protected formIcon(scaledSize: Size): Icon {
    return {
      url: this.getIconUrl(),
      scaledSize,
    };
  }

  protected getIconSize(_count: number): number {
    return MapSettings.SMALL_MARKER_SIZE;
  }

  /**
   * @description Configures the marker icon scaled size depend on
   *              aggregated count value.
   * @param { number } count
   * @returns { google.maps.Size }
   */
  protected configureScaledSize(count: number): Size {
    const size: number = this.getIconSize(count);

    return { width: size, height: size };
  }
}
